import React, { useState, useEffect } from "react";
import { useSearchQuery, usePagination } from "../../../hooks";
import { MPSharedTable, MPSharedDeleteModal, MPSharedHeader } from "../Shared";
import { useGetVManModelsQuery, useDeleteVManModelMutation } from "../services";
import { VManModelForm } from "./form";
import { useDelete } from "../../../hooks";
import { getLocalizedString } from "../../../shared/translation";

export const VManModelsContainer = () => {
  const { page, setPage, perPage, pagination } = usePagination();

  const { setSimpleSearch, setAdvanceSearch, q } = useSearchQuery({
    page,
    setPage,
    simpleSearchKey: "name_cont",
  });

  const {
    data = { data: [], total_count: 0 },
    error,
    isFetching,
    isSuccess,
  } = useGetVManModelsQuery({
    page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
    q,
  });

  const {
    deleteItem: deleteVManModel,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteVManModelMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const onEdit = (datum) => {
    setShowForm(true);
    setIdToEdit(datum.id);
  };

  const onDelete = (datum) => {
    setShowDeleteWarning(true);
    setIdToDelete(datum.id);
  };

  const onCreate = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToEdit, setIdToEdit] = useState(null);

  const headers = [
    {
      label: getLocalizedString("name", "Name"),
      key: "name",
      className: "name",
    },
    {
      label: getLocalizedString("manufacturer", "Manufacturer"),
      key: "vehicle_manufacturer_name",
      className: "manufacturer",
    },
    {
      label: getLocalizedString("added_on", "Added On"),
      key: "created_at",
      className: "date",
    },
  ];

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data?.findIndex((item) => item.id === id);
    if (index >= 0) {
      name = data?.data[index]?.name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container vehicla-models">
        <MPSharedHeader
          groupName="vehicle"
          heading={getLocalizedString("vehicles", "Vehicles")}
          createNewHandler={onCreate}
          resourceName="Vehicle Manufacturer Models"
          handleSearchKey={setSimpleSearch}
          simpleSearchPlaceholder={getLocalizedString("search_by_name", "Search by Name")}
        />

        <MPSharedTable
          resourceName="Vehicle Manufacturer Models"
          data={data.data || []}
          error={error}
          isLoading={isFetching}
          isSuccess={isSuccess}
          headers={headers}
          onDelete={onDelete}
          onEdit={onEdit}
          pagination={{ ...pagination, count: data.total_count }}
          className="vehicle-models"
          auditResource="VehicleManufacturerModel"
          auditKey="name"
        />
      </article>

      <MPSharedDeleteModal
        show={showDeleteWarning}
        entityName={getLocalizedString("vehicle_manufacturer_model", "Vehicle Manufacturer Model")}
        error={deleteErrorMsg}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        itemName={getDeleteItemName(idToDelete)}
        onDelete={() => deleteVManModel({ id: idToDelete })}
      />
      {showForm && <VManModelForm idToEdit={idToEdit} onClose={setShowForm} />}
    </>
  );
};
